<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <div v-if="isUpdate" class="my-4 d-flex justify-center">
      <v-avatar size="120">
        <img
          class="justify-center"
          style="object-fit: cover;"
          :src="candidateAvatar"
        >
      </v-avatar>
    </div>
    <form @submit.prevent="handleSubmit(onSave)">
      <ValidationProvider name="Ad Soyad" rules="required" v-slot="{ errors }">
        <v-text-field v-model="form.Name" label="Ad Soyad" :error-messages="errors" outlined />
      </ValidationProvider>
      <ValidationProvider name="Sicil" rules="required" v-slot="{ errors }">
        <v-text-field v-model="form.Username" label="Sicil Numarası" :error-messages="errors" outlined />
      </ValidationProvider>
      <ValidationProvider name="Fotoğraf" :rules="isUpdate ? '' : 'required'" v-slot="{ errors }">
        <v-file-input v-model="form.Photo" label="Fotoğraf Yükle" :error-messages="errors" outlined accept="image/*" />
      </ValidationProvider>
      <ValidationProvider name="Tanıtım" :rules="required" v-slot="{ errors }">
        <v-textarea v-model="form.Biography" label="Tanıtım Bilgisi" :error-messages="errors" outlined />
      </ValidationProvider>
      <v-card-actions class="justify-center">
        <v-btn color="primary" type="submit">Kaydet</v-btn>
        <v-btn text @click="$emit('cancel')">İptal</v-btn>
      </v-card-actions>
     
    </form>
  </ValidationObserver>
</template>

<script>
import FileService from '../services/FileService'
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: { ValidationObserver, ValidationProvider },
  props: {
    isUpdate: {
      type:  Boolean,
      default: false,
    },
    initialForm: {
      type:  Object,
      default: () => null,
    },
  },
  mounted(){
    if(this.initialForm){
      this.form = this.initialForm;
    }
  },
  computed: {
    candidateAvatar(){
      return FileService.getFileString(this.form.PhotoFileId)
    }
  },
  data() {
    return {
      form: {
        Name: '',
        Username: '',
        Photo: null,
        Description: '',
      },
    };
  },
  methods: {
    onSave() {
      this.$emit('save', { candidate: this.form, isUpdate: this.isUpdate });
    },
  },
};
</script>
